/**
 * Limpia completamente el caché de Firestore en IndexedDB
 * Esto resuelve el error: INTERNAL ASSERTION FAILED (ID: ca9)
 */
export async function clearFirestoreCache(): Promise<void> {
  if (typeof window === 'undefined' || !window.indexedDB?.databases) {
    return;
  }

  try {
    // Obtener todas las bases de datos
    const databases = await window.indexedDB.databases();
    
    // Eliminar todas las bases de datos de Firestore
    for (const db of databases) {
      if (db.name && db.name.includes('firestore')) {
        await new Promise<void>((resolve, reject) => {
          const request = window.indexedDB.deleteDatabase(db.name!);
          request.onsuccess = () => resolve();
          request.onerror = () => reject(request.error);
          request.onblocked = () => {
            resolve(); // Continuar de todos modos
          };
        });
      }
    }

  } catch (error) {
  }
}

/**
 * Verifica si necesita limpiar el caché
 * Se ejecuta solo una vez después del despliegue
 */
export function shouldClearCache(): boolean {
  const CACHE_VERSION = 'v2'; // Incrementa esto para forzar limpieza
  const lastClearVersion = localStorage.getItem('firestore_cache_clear_version');

  if (lastClearVersion !== CACHE_VERSION) {
    localStorage.setItem('firestore_cache_clear_version', CACHE_VERSION);
    return true;
  }

  return false;
}
